@mixin footerButton($borderColor) {
  border: 1px solid #{$borderColor};
  border-radius: 5px;
  padding-top: 2px;
  padding-bottom: 2px;
  color: #F2F4F6;
}

.user-prompt {
  .modal-backdrop {
    display: flex !important;
    .modal-dialog {
     // width: 450px;
      margin: auto;
      .modal-content {
        border: 2px solid #3C4756;
        border-radius: 7px;
        .modal-header {
          background: #262F39;
          color: #C1CAD6;
          text-align: center;
          padding-top: 0;
          padding-bottom: 0;
          border-bottom: 0;
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;
          .modal-title {
          }
        }
        .modal-body {
          background: #1D232C;
          .text {
            text-align: center;
            color: #8491A2;
            font-size: 20px;
            font-weight: 100;
            font-family: "Solomon_Normal";
          }
        }
        .modal-footer {
          border-top: 0;
          background: #262F39;
          color: whitesmoke;
          text-align: center;
          cursor: pointer;
          border-bottom-right-radius: 5px;
          border-bottom-left-radius: 5px;
          padding-top: 9px;
          padding-bottom: 9px;
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-prod-baristadj-server/src/app/components/user-prompts/user-prompts.scss